// import { compose, equals, takeLast, uniq } from 'ramda'
// import { useEffect } from 'react'
// import { useRecoilState, useSetRecoilState } from 'recoil'
import { fetchArtisanUrl } from 'services/artisans'
import { fetchProduct } from 'services/products'

// import marshalProductToProductProps from 'converters/marshalProductToProductProps'
// import { productHistoryAtom, productHistorySessionAtom, productHistoryStorageAtom } from 'state/atoms'
import Breadcrumb from 'components/Breadcrumb'
import Product from 'components/Product'

import { fetchCollectionCrumbs } from './[handle].helpers'
import { BreadcrumbWrapper } from './[handle].style'

// TODO: GA tracking

// const takeLast5 = takeLast(5)
// const takeLast5Uniq = compose(takeLast5, uniq)

export default function ProductPage({ product, skuId, crumbs, artisanUrl }) {
  // const [productHistorySession, setProductHistorySession] = useRecoilState(productHistorySessionAtom)

  // useEffect(() => {
  //   const prevProductHistory = [...productHistorySession]
  //   const newProductHistory = takeLast5Uniq([...prevProductHistory, product.handle])

  //   if (equals(prevProductHistory, newProductHistory)) return

  //   setProductHistorySession(newProductHistory)
  // }, [product, productHistorySession, setProductHistorySession])

  return (
    <div>
      {/* <Debug>{productHistorySession}</Debug> */}
      <BreadcrumbWrapper>
        <Breadcrumb crumbs={crumbs} />
      </BreadcrumbWrapper>
      <Product product={product} skuId={skuId} artisanUrl={artisanUrl} />
    </div>
  )
}

export async function getServerSideProps({ params, query, res }) {
  const { uid, handle } = params
  const { variant: skuId } = query

  const product = await fetchProduct(handle, skuId)

  if (!product) {
    return {
      notFound: true,
    }
  }

  const collectionCrumbs = await fetchCollectionCrumbs(uid)

  const artisanUrl = await fetchArtisanUrl(product.artisan)

  const crumbs = [{ title: product.title }]

  if (artisanUrl) crumbs.unshift({ url: artisanUrl, title: product.artisan })
  if (collectionCrumbs) crumbs.unshift.apply(crumbs, collectionCrumbs)

  res.setHeader('Link', `<https://thearmoury.com/products/${handle}?variant=${skuId}>; rel="canonical"`)

  return {
    props: {
      product,
      skuId: skuId || null,
      crumbs,
      artisanUrl,
    },
  }
}
